import { render } from "./ClasElem_ClasAseg.vue?vue&type=template&id=25577fd2"
import script from "./ClasElem_ClasAseg.vue?vue&type=script&lang=js"
export * from "./ClasElem_ClasAseg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__